import { EditTwoTone } from "@ant-design/icons";
import React from "react";

function EditCategoriesIcon({ categories, onEdit }) {
    return <EditTwoTone onClick={() => onEdit(categories)} style={{ cursor: "pointer" }} />;
}

export default EditCategoriesIcon;